import React, { useState } from "react";
import DiligentClientPortalDemoVideo from "../assets/videos/Diligent Client Portal Demo.mp4";
import PdfDownload from "./PDFDownload";
import { emails } from "../constants";
import AccordionCard from "./AccordionCard";
import { BsTelephone } from "react-icons/bs";
import SettingCustomerPermissions from "../assets/videos/Client Tutorials/Settings Customer Permissions.mp4";
import ManagingReturnRequests from "../assets/videos/Client Tutorials/Managing Returns Request.mp4";
import ReturnPermissionsTableOverview from "../assets/videos/Client Tutorials/Table Overview.mp4";
import ReturnUpgradesAndNewLook from "../assets/videos/Client Tutorials/Returns - Client.mp4";
import { DiliTextCP } from "./Utility/DiliTextCP";
import { HelmetUtil } from "./Utility/HelmetUtil";
import { VideoModal } from "./Utility/VideoModal";
import { HighlightText } from "./Utility/HighlightText";
import { RestrictedContent } from "./Navbar/RestrictedContent";

const PDFS = {
  userGuidePdf: "Users Guide - Version 1.pdf",
};

const videoGuides = [
  {
    video: DiligentClientPortalDemoVideo,
    title: "Diligent Client Portal Demo",
  },
  {
    video: SettingCustomerPermissions,
    title: "Setting Customer Permissions",
  },
  {
    video: ManagingReturnRequests,
    title: "Managing Return Requests",
  },
  {
    video: ReturnPermissionsTableOverview,
    title: "Return Permissions Table Overview",
  },
  {
    video: ReturnUpgradesAndNewLook,
    title: "Return Upgrades and New Look",
  },
];

const HelpPage = () => {
  const [guidesSearchFilter, setGuidesSearchFilter] = useState("");
  const handleChangeGuidesSearchFilter = (event) => {
    setGuidesSearchFilter(event.target.value);
  };

  const [showVideoModal, setShowVideoModal] = useState();
  const [selectedVideoIndex, setSelectedVideoIndex] = useState();
  const handleSelectVideo = (videoThatWasClicked) => {
    setSelectedVideoIndex(videoThatWasClicked);
    setShowVideoModal(true);
  };
  const handleCloseVideo = () => {
    setShowVideoModal(false);
    setSelectedVideoIndex();
  };

  const filteredVideoGuides = videoGuides.filter(
    (guide) =>
      guidesSearchFilter === "" ||
      guide?.title.toLowerCase().includes(guidesSearchFilter.toLowerCase())
  );

  return (
    <>
      <VideoModal
        show={showVideoModal}
        onHide={handleCloseVideo}
        videoSrc={videoGuides[selectedVideoIndex]?.video}
        videoTitle={videoGuides[selectedVideoIndex]?.title}
      />
      <HelmetUtil title="Help" />
      <div className="help-page">
        <h1 className="help-page-heading">Help</h1>

        <div className="help-page-container container form-container px-0 py-0">
          <RestrictedContent>
            <div className="help-page-video-container container form-container">
              {/* <div style={{ display: selectedVideoIndex != null ? "" : "none" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <h3>
                  <BackButton
                    classNameAppend=""
                    onClick={() => {
                      handleCloseVideo();
                    }}
                  />

                  {videoGuides[selectedVideoIndex]?.title}
                </h3>
              </div>
              <div className="py-4">
                <video
                  key={videoGuides[selectedVideoIndex]?.title}
                  preload=""
                  controls
                  autoPlay
                  style={{ width: "100%", borderRadius: ".5rem" }}
                >
                  <source
                    src={videoGuides[selectedVideoIndex]?.video}
                    type="video/mp4"
                  />
                </video>
              </div>
            </div> */}
              <div
              // style={{ display: selectedVideoIndex == null ? "" : "none" }}
              >
                <div className="d-flex justify-content-between">
                  <h3>Video Guides</h3>
                  <DiliTextCP
                    inputStyle={{ boxShadow: "0px 0px 5px rgba(0,0,5,.2)" }}
                    value={guidesSearchFilter}
                    onChange={handleChangeGuidesSearchFilter}
                    placeholder="Search"
                  ></DiliTextCP>
                </div>

                <div className="pt-4 pb-2">
                  <div
                    className="panel-flat"
                    style={{ boxShadow: "0px 0px 5px rgba(0,0,0,.1)" }}
                  >
                    {filteredVideoGuides.length > 0 ? (
                      filteredVideoGuides.map((guide, index) => {
                        return (
                          <a
                            role="button"
                            style={{ display: "block" }}
                            className="px-2 py-2 remove-last-item-border help-guide-video-list-item clickable"
                            onClick={() => {
                              handleSelectVideo(index);
                            }}
                          >
                            <HighlightText
                              fullText={guide.title}
                              textToHighlight={guidesSearchFilter}
                            />
                            {/* {guide.title} */}
                          </a>
                        );
                      })
                    ) : (
                      <div className="text-center p-2">No Results Found</div>
                    )}
                  </div>
                </div>
              </div>

              {/* <h3 className="help-page-video-heading mb-2">Demo</h3>

          <video className="diligent-client-portal-demo-video" controls>
            <source src={DiligentClientPortalDemoVideo} type="video/mp4" />
          </video> */}
            </div>
          </RestrictedContent>

          <RestrictedContent>
            <div className="container px-0 py-0 form-container">
              <PdfDownload
                title="Help Documents"
                subtitle="PDF Guides"
                eventKey="helpDocuments"
              >
                <option value={PDFS.userGuidePdf}>User Guide.pdf</option>
              </PdfDownload>
            </div>
          </RestrictedContent>
          <AccordionCard
            eventKey="helpContact"
            title="Support Contact Information"
            icon={BsTelephone}
          >
            <div>{emails.supportEmail}</div>
          </AccordionCard>
        </div>
      </div>
    </>
  );
};

export default HelpPage;
